import React from 'react';
import { ExternalLink, Check } from 'lucide-react';

const AffiliateCodes = () => {
  const casinos = [
    {
      name: "Goated",
      color: "#D7FF00",
      textColor: "black",
      features: [
        "VIP Transfer",
        "Daily Bonuses",
        "Wager Leaderboard"
      ],
      code: "VICO",
      link: "https://www.goated.com/r/VICO"
    },
    {
      name: "Shuffle",
      color: "#5b1d8c",
      textColor: "white",
      features: [
        "Daily Bonuses",
        "24/7 Support",
        "Instant Withdrawals"
      ],
      code: "VICO",
      link: "https://shuffle.com/?r=VICO"
    },
    {
      name: "Gamba",
      color: "#48e39f",
      textColor: "black",
      features: [
        "Daily Bonuses",
        "24/7 Support",
        "Instant Withdrawals"
      ],
      code: "VICO",
      link: "https://gamba.com?c=VICO"
    },
    {
      name: "Upgrader",
      color: "#80dbf4",
      textColor: "black",
      features: [
        "3 Free Cases",
        "VIP Rewards",
        "Instant Withdrawals"
      ],
      code: "VICO",
      link: "https://upgrader.com/r/VICO"
    }
  ];

  return (
    <section id="casino-bonuses" className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 bg-gradient-to-r from-[#D7FF00] to-white bg-clip-text text-transparent">
          Exclusive Casino Bonuses
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {casinos.map((casino) => (
            <div
              key={casino.name}
              className="relative"
            >
              <div
                className="h-full p-6 rounded-2xl border backdrop-blur-sm transition-transform duration-300 hover:scale-105"
                style={{
                  backgroundColor: `${casino.color}10`,
                  borderColor: `${casino.color}30`
                }}
              >
                <h3
                  className="text-2xl font-bold mb-6"
                  style={{ color: casino.color }}
                >
                  {casino.name}
                </h3>

                <ul className="space-y-4 mb-8">
                  {casino.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-3">
                      <div
                        className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center"
                        style={{ backgroundColor: `${casino.color}20` }}
                      >
                        <Check
                          className="w-3 h-3"
                          style={{ color: casino.color }}
                        />
                      </div>
                      <span className="text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="space-y-4">
                  <div
                    className="p-3 rounded-lg text-center border"
                    style={{
                      backgroundColor: `${casino.color}10`,
                      borderColor: `${casino.color}30`,
                      color: casino.color
                    }}
                  >
                    <span className="text-sm text-gray-400">USE CODE</span>
                    <div className="text-lg font-bold mt-1">{casino.code}</div>
                  </div>

                  <a
                    href={casino.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 w-full py-3 rounded-lg font-bold transition-opacity duration-300 hover:opacity-90"
                    style={{
                      backgroundColor: casino.color,
                      color: casino.textColor
                    }}
                  >
                    Claim Bonus
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AffiliateCodes;